export const HOME = {
  heroHeadline: 'hero-headline',
  heroExploreButton: 'hero-explore-rooms-button',
  channelTile: 'channel-tile',
};

export const NAV = {
  global: 'global-nav',
  mobileOpenButton: 'mobile-nav-open-button',
  mobileRoomLink: 'mobile-nav-room-link',
  navWatch: 'nav-watch',
  navListen: 'nav-listen',
  navRead: 'nav-read',
  navCollect: 'nav-collect',
  enterLounge: 'enter-the-lounge-button',
};

export const NEWSLETTER = {
  emailInput: 'newsletter-email-input',
  submitButton: 'newsletter-submit-button',
  successMessage: 'newsletter-success-message',
  errorMessage: 'newsletter-error-message',
};

export const COLLECT = {
  productCard: 'collect-product-card',
  buyNowButton: 'collect-buy-now-button',
  checkoutSuccess: 'checkout-success-message',
  downloadLink: 'checkout-download-link',
};

// Legacy aliases (kept so older test scripts still work)
export const VAULT = COLLECT;

export const AUDIO = {
  player: 'audio-player',
  playButton: 'audio-player-play-button',
};

export const ADMIN = {
  emailInput: 'admin-email-input',
  passwordInput: 'admin-password-input',
  submit: 'admin-login-submit-button',
  navTab: 'admin-nav-tab',
  createButton: 'admin-create-button',
  saveButton: 'admin-save-button',
  deleteButton: 'admin-delete-button',
  uploadButton: 'admin-upload-button',
};
